import { getBlob, getStorage, ref } from "firebase/storage";

export const getFileUrl = async (pathToFile: string) => {
  const storage = getStorage();
  const blob = await getBlob(ref(storage, pathToFile));
  return URL.createObjectURL(blob);
};
